import { render } from "./ParAgent.vue?vue&type=template&id=228d4ad2"
import script from "./ParAgent.vue?vue&type=script&lang=js"
export * from "./ParAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__